import React from 'react';
import PickerModal from '../PickerModal';
import localization from '@progressivebeef/shared/src/localization/i18n';
import { getLocale } from '@progressivebeef/shared/src/services/storageService/GlobalData';
import CustomButton from '../CustomButton';

const RecordPickerModal = ({
  show,
  onRequestClose,
  onViewDocument,
  onEditDocument,
  onDeleteDocument,
  readOnly = false,
  isEdit = true,
  isDelete = true,
}) => {
  return (
    <PickerModal show={show} onRequestClose={onRequestClose} backgroundColor="#502D7F">
      <div>
        <CustomButton
          title={localization[getLocale()].VIEW_DOCUMENT}
          onPressEvent={onViewDocument}
        />
        
        {!readOnly && (
          <>
            {isEdit && (
              <CustomButton
                title={localization[getLocale()].EDIT_DOCUMENT}
                onPressEvent={onEditDocument}
              />
            )}
            {isDelete && (
              <CustomButton
                title={localization[getLocale()].DELETE_DOCUMENT}
                onPressEvent={onDeleteDocument}
              />
            )}
          </>
        )}
      </div>
      <div className="cancel-btn-box">
         <CustomButton
          title={localization[getLocale()].CANCEL}
          buttonColor="#949494"
          textColor="white"
          onPressEvent={onRequestClose}
        />
      </div>
    </PickerModal>
  );
};

export default RecordPickerModal;
